import { render, staticRenderFns } from "./Score.vue?vue&type=template&id=078f4588"
import script from "./Score.vue?vue&type=script&lang=js"
export * from "./Score.vue?vue&type=script&lang=js"
import style0 from "./Score.vue?vue&type=style&index=0&id=078f4588&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports